import React from "react";
import { ascendingBreakpoints, Breakpoint, breakpoints } from "../components";

interface MediaQuery {
  device: Device;
  size: ScreenSize;
  dimensions: {
    width: number;
    height: number;
  };
}

export function useMediaQuery(): MediaQuery {
  const [dimensions, setDimensions] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  let size = "xs" as ScreenSize;

  ascendingBreakpoints.forEach((breakpoint: Breakpoint) => {
    if (dimensions.width >= breakpoints[breakpoint]) {
      size = breakpoint;
    }
  });

  const device =
    size === "xs" || size === "sm"
      ? "mobile"
      : size === "md"
      ? "tablet"
      : "desktop";

  return {
    dimensions,
    size,
    device,
  };
}

type Device = "mobile" | "tablet" | "desktop";
type ScreenSize = "xs" | "sm" | "md" | "lg" | "xl";
